window.addEventListener("load", function () {
    const popupSave = document.querySelector('#popup_save');
    if (!popupSave) return;

    const imageSave = popupSave.querySelector('.image-save img');
    const btnDownload = popupSave.querySelector('.btn_download');
    const btnShare = popupSave.querySelector('.btn_share');

    // Danh sách 4 hình + URL share tương ứng
    const images = [
        { 
            src: 'https://global-mainsite.mto.zing.vn/products/ddtank/landing/2025-tw-year-end/dist/assets/libraryMainsite-t-popup/images/save/1.jpeg', 
            shareUrl: 'https://ddtank.vnggames.tw/share1'
        },
        { 
            src: 'https://global-mainsite.mto.zing.vn/products/ddtank/landing/2025-tw-year-end/dist/assets/libraryMainsite-t-popup/images/save/2.jpeg', 
            shareUrl: 'https://ddtank.vnggames.tw/share2'
        },
        { 
            src: 'https://global-mainsite.mto.zing.vn/products/ddtank/landing/2025-tw-year-end/dist/assets/libraryMainsite-t-popup/images/save/3.jpeg', 
            shareUrl: 'https://ddtank.vnggames.tw/share3'
        },
        { 
            src: 'https://global-mainsite.mto.zing.vn/products/ddtank/landing/2025-tw-year-end/dist/assets/libraryMainsite-t-popup/images/save/4.jpeg', 
            shareUrl: 'https://ddtank.vnggames.tw/share4'
        }
    ];

    let currentImage = null;
    const COOKIE_NAME = 'ddtank_save_result';
    const COOKIE_EXPIRY_DAYS = 1;

    // Hàm helper để đọc cookie
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    // Hàm helper để ghi cookie
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function randomImage() {
        // Kiểm tra isLogin_ (có thể là biến global hoặc trong window)
        const isLogin_ = (typeof window.isLogin_ !== 'undefined') ? window.isLogin_ : null;
        
        if (isLogin_ !== 1) {
            return; // Không cho phép random nếu chưa login
        }

        // Kiểm tra cookie trước
        const savedResult = getCookie(COOKIE_NAME);
        if (savedResult) {
            // Nếu có cookie, parse và dùng kết quả đã lưu
            try {
                const savedData = JSON.parse(savedResult);
                const savedIndex = parseInt(savedData.index);
                if (savedIndex >= 0 && savedIndex < images.length) {
                    currentImage = images[savedIndex];
                    if (imageSave) {
                        imageSave.src = currentImage.src;
                    }
                    return;
                }
            } catch (e) {
                // Nếu parse lỗi, tiếp tục random mới
            }
        }

        // Random mới và lưu vào cookie
        const randomIndex = Math.floor(Math.random() * images.length);
        currentImage = images[randomIndex];
        if (imageSave) {
            imageSave.src = currentImage.src;
        }
        
        // Lưu kết quả vào cookie
        setCookie(COOKIE_NAME, JSON.stringify({ index: randomIndex }), COOKIE_EXPIRY_DAYS);
    }

    // Random khi popup mở
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (popupSave.classList.contains('active')) {
                    // Reset animation để có thể chạy lại
                    if (imageSave) {
                        imageSave.style.animation = 'none';
                        // Force reflow để reset animation
                        void imageSave.offsetWidth;
                        imageSave.style.animation = '';
                    }
                    randomImage();
                }
            }
        });
    });
    observer.observe(popupSave, { attributes: true, attributeFilter: ['class'] });

    if (popupSave.classList.contains('active')) {
        randomImage();
    }

    // Download hình
    if (btnDownload) {
        btnDownload.addEventListener('click', async function(e) {
            e.preventDefault();
            if (currentImage && currentImage.src) {
                try {
                    const response = await fetch(currentImage.src);
                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = `ddtank-save-${Date.now()}.jpeg`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    window.URL.revokeObjectURL(blobUrl);
                } catch (err) {
                    window.open(currentImage.src, '_blank');
                }
            }
        });
    }

    // Share Facebook
    if (btnShare) {
        btnShare.addEventListener('click', function(e) {
            e.preventDefault();
            // Lấy shareUrl từ hình ảnh đang hiển thị để đảm bảo đúng
            let shareUrl = null;
            
            if (imageSave && imageSave.src) {
                // Tìm hình ảnh tương ứng với src đang hiển thị
                const currentSrc = imageSave.src;
                const foundImage = images.find(img => img.src === currentSrc);
                if (foundImage && foundImage.shareUrl) {
                    shareUrl = foundImage.shareUrl;
                }
            }
            
            // Nếu không tìm thấy từ hình ảnh, thử lấy từ currentImage
            if (!shareUrl && currentImage && currentImage.shareUrl) {
                shareUrl = currentImage.shareUrl;
            }
            
            // Nếu vẫn không có, thử lấy từ cookie
            if (!shareUrl) {
                const savedResult = getCookie(COOKIE_NAME);
                if (savedResult) {
                    try {
                        const savedData = JSON.parse(savedResult);
                        const savedIndex = parseInt(savedData.index);
                        if (savedIndex >= 0 && savedIndex < images.length && images[savedIndex].shareUrl) {
                            shareUrl = images[savedIndex].shareUrl;
                        }
                    } catch (e) {
                        // Nếu parse lỗi, bỏ qua
                    }
                }
            }
            
            if (shareUrl) {
                // Mở popup share Facebook với URL tĩnh
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, 
                    'facebook-share', 
                    'width=626,height=436'
                );
            }
        });
    }
});

